import { Suspense } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';
import { useRoutes } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from 'styled-components';

// Components
import { ErrorScreen, Bootstrap } from '..';

// Redux and Queries
import { store } from '../../store';

import { routes as routesConfig } from '../../routes';

// Global Styles
import { GlobalStyles } from '@gif/shared-global';
import { light, GlobalBodyStyles } from '@mlb/play-ui';

const faviconUrl =
  '//builds.mlbstatic.com/mlb.com/builds/site-core/1602555573814/dist/images/favicon.png';
const appleTouchIconUrl =
  '//www.mlbstatic.com/mlb.com/images/logos/apple-touch-icons-180x180/mlb.png';

export function App() {
  const routes = useRoutes(routesConfig);
  // const theme = useThemeSwitcher();
  // TODO: create fallback for React.Suspense
  return (
    <ThemeProvider theme={light}>
      <ReduxProvider store={store}>
        <GlobalStyles $additionalCss={GlobalBodyStyles} />
        <Bootstrap />
        <HelmetProvider context={{}}>
          <Helmet>
            <link rel="icon" type="image/png" href={faviconUrl} />
            <link rel="apple-touch-icon" href={appleTouchIconUrl} />
          </Helmet>
          <ErrorBoundary FallbackComponent={ErrorScreen}>
            <Suspense fallback={null}>{routes}</Suspense>
          </ErrorBoundary>
        </HelmetProvider>
      </ReduxProvider>
    </ThemeProvider>
  );
}

export default App;
